import React, { useEffect, useState } from "react";
import Tabs from "common/components/ui/Tab";
import GlobalActionManager from "../components/GlobalActionManager";

const GlobalActionPage = () => {
  const tabs = [
    {
      id: "tab1",
      label: "Global Actions",
      content: <GlobalActionManager />,
    },
    /*{
      id: "tab2",
      label: "Collections",
      content: <h2>Collections</h2>,
    },*/
  ];
  return (
    <div className='container-fluid '>
      <div className='mx-3'>
        <h3 className='fs-1 mt-3 fw-bolder'>Actions</h3>
        <div>
          <Tabs tabs={tabs} />
        </div>
      </div>
    </div>
  );
};

export default GlobalActionPage;
